import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './styles/provision-system-information';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import { translate } from 'react-i18next';

class ProvisionSystemInformation extends React.Component {

  render() {
    const {
      t,
      systemId,
      productId,
      productVersion,
      description,
      onSystemId,
      onProductId,
      onProductVersion,
      onDescription,
      versions,
      disabled
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value,
      onChange: (event) => fn(event.target.value)
    });
    return (
      <React.Fragment>
        <div className={classes.titleContainer}>
          <h6 className={classes.title}>{t('provisionSystemInformation.title')}</h6>
        </div>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="provision_systemId">{t('provisionSystemInformation.systemIdLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="text"
                name="provision_systemId"
                id="provision_systemId"
                placeholder={t('provisionSystemInformation.systemIdPlaceholder')}
                disabled={disabled}
                {...getFieldProps(systemId, onSystemId)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="provision_productId">{t('provisionSystemInformation.productIdLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="select"
                name="provision_productId"
                id="provision_productId"
                disabled={disabled}
                {...getFieldProps(productId, onProductId)}
              >
                <option value="" disabled>{t('provisionSystemInformation.productIdPlaceholder')}</option>
                {
                  Object.keys(versions)
                    .map(
                      (identifier, index) => <option value={identifier} key={index}>{identifier}</option>
                    )
                }
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="provision_productVersion">{t('provisionSystemInformation.productVersionLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="select"
                name="provision_productVersion"
                id="provision_productVersion"
                disabled={disabled}
                {...getFieldProps(productVersion, onProductVersion)}
              >
                <option value="" disabled>{t('provisionSystemInformation.productVersionPlaceholder')}</option>
                {
                  (versions[productId] || [])
                    .map(
                      (identifier, index) => <option value={identifier} key={index}>{identifier}</option>
                    )
                }
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label for="provision_description">{t('provisionSystemInformation.descriptionLabel')}<span className={classes.requiredIndicator}>*</span></Label>
          <Input
            type="text"
            name="provision_description"
            id="provision_description"
            placeholder={t('provisionSystemInformation.descriptionPlaceholder')}
            disabled={disabled}
            {...getFieldProps(description, onDescription)}
          />
        </FormGroup>
      </React.Fragment>
    )
  }

}

ProvisionSystemInformation.propTypes = {
  systemId: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  productVersion: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onSystemId: PropTypes.func.isRequired,
  onProductId: PropTypes.func.isRequired,
  onProductVersion: PropTypes.func.isRequired,
  onDescription: PropTypes.func.isRequired,
  // Map where the keys are the products, and the values are arrays of available versions
  versions: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

export default translate(['pending'])(ProvisionSystemInformation);


// WEBPACK FOOTER //
// ./src/views/pending-product-instance/provision-system-information.js